import { render, staticRenderFns } from "./CombinationsConfiguratorCanvas.vue?vue&type=template&id=75003082&scoped=true"
import script from "./CombinationsConfiguratorCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsConfiguratorCanvas.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75003082",
  null
  
)

export default component.exports